// extracted by mini-css-extract-plugin
module.exports = {"container":"Skills_container__3WrWO","heading":"Skills_heading__Ai3sG","grid":"Skills_grid__37PzC","skillBox":"Skills_skillBox__2Ijeb","skillName":"Skills_skillName__1qoUe"};